import moment from "moment";

export const FichaAfiliacionMixin = {
  computed: {
    isSelectFicha: function () {
      if (this.model.period === 1 || this.model.period === 3) {
        return true
      }

      return this.model.seleccionado !== '';
    },
  },
  methods: {
    generate(rut = null) {
      let last = true
      let id = null
      if (this.model.period === 3) {
        last = false
      } else if (this.model.period === 2) {
        last = false
        id = this.model.seleccionado
      }

      const loading = this.getLoading()
      this.$log.debug(rut)
      this.getFichaAfiliacion(last, id, rut)
        .then(response => {
          this.$log.debug('getFichaAfiliacion', response.data.statusCode)

          if (response.data.statusCode === 200) {
            const data = response.data.datos
            let link = document.createElement('a')
            link.href = data
            const date = moment().format('YYYYMMDDhhmmss')
            link.download = `ficha-${date}.pdf`
            link.click();
          } else if (response.data.statusCode === 404) {
            this.$log.error('No se encuentra la ficha de afiliación', response.data.datos)
            this.showWarn('No tiene una ficha de afiliación asociada')
          } else {
            this.$log.error('Error al generar la ficha de afiliación', response.data.datos)
            this.showError('Se ha producido un error al generar la ficha de afiliación, inténtelo nuevamente')
          }
        })
        .catch(err => {
          this.$log.fatal('getFichaAfiliacion', err, err.response, err.request)
          this.errored = true
          this.showError('Ocurrió un error inesperado al cargar los datos')
        })
        .finally(() => {
          loading.close()
        })
    },
    selectPeriod() {
      if (this.model.period === 2) {
        this.listaAfiliacionAceptada()
      }
    },
    listaAfiliacionAceptada(rut = null) {
      this.loading = true

      this.getListaAfiliacionAceptada(rut)
        .then(response => {
          this.$log.debug('getListaAfiliacionAceptada', response.data.statusCode)

          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos)

            this.$log.debug(data)
            if (data.length === 0) {
              this.errored = true
              this.showInfo('No hay afiliaciones aceptadas para su persona')
              return
            }
            this.model.afiliaciones = data.map(row => {
              row.fecha = moment.utc(row.fecha).local().format('DD-MM-YYYY HH:mm')
              return row
            })
            this.$log.debug(this.model.afiliaciones)

          } else if (response.data.statusCode === 404) {
            this.showInfo('No hay afiliaciones aceptadas para su persona')
            return
          } else {
            this.errored = true
            this.showError('Ocurrió un error inesperado al cargar los datos')
          }
        })
        .catch(err => {
          this.$log.fatal('getListaAfiliacionAceptada', err, err.response, err.request)
          this.errored = true
          this.showError('Ocurrió un error inesperado al cargar los datos')
        })
        .finally(() => {
          this.loading = false
        })
    },
  }

}
